
export { flashMessageAPI } from "/opt/atlassian/pipelines/agent/build/packages/modules/module-core/src/modules/stores/index.ts"